
import { Routes } from '@angular/router';
import { Home } from './components/home/home';
import { DirectorsAdvisors } from './components/about/directors-advisors/directors-advisors';
import { Timeline } from './components/about/timeline/timeline';
import { Platforms } from './components/services/platforms/platforms';
import { Projects } from './components/services/projects/projects';
import { QA } from './components/services/qa/qa';
import { ITServices } from './components/services/it-services/it-services';
import { Career } from './components/career/career';
import { CareerDetails } from './components/career/career-details/career-details';
import { ContactUs } from './components/contact-us/contact-us';
import { Management } from './components/about/management/management';

export const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', component: Home },
  { path: 'team', component: Management },
  { path: 'directors-advisors', component: DirectorsAdvisors },
  { path: 'timeline', component: Timeline },
  { path: 'platforms', component: Platforms },
  { path: 'projects', component: Projects },
  { path: 'qa-service', component: QA },
  { path: 'it-services', component: ITServices },
  { path: 'career', component: Career },
  { path: 'career/:id', component: CareerDetails },
  { path: 'contact-us', component: ContactUs },
  { path: '**', redirectTo: '/home' }
];
